import app from './app';
import auth from './auth';
import organization from './organization';
import users from './users';
import cluster from './cluster';
import admin from './admin';
import node from './node';
import vms from './vms';
import deployments from './deployments';
import deploymentReleases from './deployment-release';
import deploymentReleaseJobs from './deployment-release-job';
import deploymentApplications from './deployment-applications';
import clusterGroups from './cluster-groups';
import incidents from './incidents';
import alertPolicies from './alert-policies';
import notificationChannels from './notification-channels';

export default [
  ...app,
   ...auth,
   ...organization,
   ...users,
   ...cluster,
   ...node,
   ...admin,
   ...vms,
   ...deployments,
   ...deploymentApplications,
   ...clusterGroups,
   ...deploymentReleases,
   ...deploymentReleaseJobs,
   ...incidents,
   ...alertPolicies,
   ...notificationChannels
];
